import React, { useEffect, useState } from "react";
import API from "../../apiService";

const ObjectiveGizi = ({ onDataChange, patient }) => {

    const refBbu = [
        'Berat badan sangat kurang (severely underweight)',
        'Berat badan kurang (underweight)',
        'Berat badan normal',
        'Risiko Berat badan lebih',
    ]
    const refTbu = [
        'Sangat pendek (severely stunted)',
        'Pendek (stunted)',
        'Normal',
        'Tinggi',
    ]
    const refBbTb = [
        'Gizi buruk (severely wasted)',
        'Gizi kurang (wasted)',
        'Gizi baik (normal)',
        'Berisiko gizi lebih (possible risk of overweight)',
        'Gizi lebih (overweight)',
        'Obesitas (obese)',
    ]

    const [id, setId] = useState('')
    const [bbu, setBbu] = useState('Berat badan normal')
    const [tbu, setTbu] = useState('Normal')
    const [bbtb, setBbtb] = useState('Gizi baik (normal)')
    const [lila, setLila] = useState('')
    const [rl, setRl] = useState('')
    const [estimasiTb, setEstimasiTb] = useState('')
    const [estimasiBbi, setEstimasiBbi] = useState('')
    const [kesimpulan, setKesimpulan] = useState('')
    const [kesimpulanBio, setKesimpulanBio] = useState('')
    const [git, setGit] = useState([])
    const [refGit, setRefGit] = useState([
        { name: "Mual", status: false },
        { name: "Diare", status: false },
        { name: "Konstipasi", status: false },
        { name: "Sulit Menelan", status: false },
    ])
    const [otherGit, setOtherGit] = useState('')
    const [pemeriksaanPenunjang, setPemerikaanPenunjang] = useState('')
    const [kesimpulanFisik, setKesimpulanFisik] = useState('')
    const [isAlergiMakanan, setIsAlergiMakanan] = useState(false)
    const [alergiMakanan, setAlergiMakanan] = useState('')
    const [isPantanganMakanan, setIsPantanganMakanan] = useState(false)
    const [pantanganMakanan, setPantanganMakanan] = useState('')
    const [diet, setDiet] = useState('')

    const [nasi1, setNasi1] = useState('')
    const [nasi2, setNasi2] = useState('')
    const [lh1, setLh1] = useState('')
    const [lh2, setLh2] = useState('')
    const [ln1, setLn1] = useState('')
    const [ln2, setLn2] = useState('')
    const [sayur1, setSayur1] = useState('')
    const [sayur2, setSayur2] = useState('')
    const [buah1, setBuah1] = useState('')
    const [buah2, setBuah2] = useState('hr')
    const [selingan1, setSelingan1] = useState('')
    const [selingan2, setSelingan2] = useState('')
    const [selingan3, setSelingan3] = useState('')
    const [recall, setRecall] = useState({})

    const [planing_diet_type, set_planing_diet_type] = useState('0')
    const [planing_energy, set_planing_energy] = useState('0')
    const [planing_carbohydrate, set_planing_carbohydrate] = useState('0')
    const [planing_protein, set_planing_protein] = useState('0')
    const [planing_fat, set_planing_fat] = useState('0')

    useEffect(() => {
        getNutrition()
    }, [])

    const getNutrition = async () => {
        const res = await API.get(`nutrition/${patient.id}`);
        if (res.code === 200) {
            const v = res.data
            setId(v.id)
            setBbu(v.bbu)
            setTbu(v.tbu)
            setBbtb(v.bb_tb)
            setLila(v.lila)
            setRl(v.rl)
            setEstimasiTb(v.estimasi_tb)
            setEstimasiBbi(v.estimasi_bbi)
            setKesimpulan(v.kesimpulan)
            setKesimpulanBio(v.kesimpulan_bio)

            const rg = [...refGit]
            const ex = v.git.split(',')
            setRefGit(rg.map(x => ({ name: x.name, status: ex.includes(x.name) })))
            setGit(v ? v.git.split(',') : [])

            setOtherGit(v.other_git)
            setPemerikaanPenunjang(v.pemeriksaan_penunjang)
            setKesimpulanFisik(v.kesimpulan_fisik)
            setIsAlergiMakanan(v.is_alergi_makanan)
            setAlergiMakanan(v.alergi_makanan)
            setIsPantanganMakanan(v.is_pantangan_makanan)
            setPantanganMakanan(v.pantangan_makanan)
            setDiet(v.diet)
            setNasi1(v.nasi1)
            setNasi2(v.nasi2)
            setLh1(v.lh1)
            setLh2(v.lh2)
            setLn1(v.ln1)
            setLn2(v.ln2)
            setSayur1(v.sayur1)
            setSayur2(v.sayur2)
            setBuah1(v.buah1)
            setBuah2(v.buah2)
            setSelingan1(v.selingan1)
            setSelingan2(v.selingan2)
            setSelingan3(v.selingan3)
            setRecall({
                recal_carbohydrate: v.recal_carbohydrate,
                recal_energy: v.recal_energy,
                recal_protein: v.recal_protein,
                recal_fat: v.recal_fat,
            })

            set_planing_diet_type(v.planing_diet_type)
            set_planing_energy(v.planing_energy)
            set_planing_carbohydrate(v.planing_carbohydrate)
            set_planing_protein(v.planing_protein)
            set_planing_fat(v.planing_fat)
        }
    }

    const mapRefGit = (v, k) => (
        <div key={`git-${k}`} className="row">
            <div className="custom-control custom-checkbox mb-3">
                <input
                    className="custom-control-input"
                    type="checkbox"
                    name={v.name}
                    onChange={(e) => {
                        if (e.target.checked) {
                            setGit([...git, v.name])
                            setRefGit(refGit.map(x => ({ ...x, status: v.name === x.name ? true : x.status })))
                        } else {
                            setGit(git.filter(v => v !== v.name))
                            setRefGit(refGit.map(x => ({ ...x, status: v.name === x.name ? false : x.status })))
                        }
                    }}
                    value={v.name}
                    id={v.name}
                    checked={v.status}
                />
                <label className="custom-control-label" htmlFor={v.name}>
                    {v.name}
                </label>
            </div>
        </div>
    )

    useEffect(() => {
        onDataChange({
            id,
            visit_id: patient.id,
            recal_energy: recall.recal_energy ?? 0,
            recal_protein: recall.recal_protein ?? 0,
            recal_fat: recall.recal_fat ?? 0,
            recal_carbohydrate: recall.recal_carbohydrate ?? 0,
            bbu,
            tbu,
            bb_tb: bbtb,
            lila: lila || 0,
            rl: rl || 0,
            estimasi_tb: estimasiTb || 0,
            estimasi_bbi: estimasiBbi || 0,
            kesimpulan: kesimpulan,
            kesimpulan_bio: kesimpulanBio,
            git: git.join(','),
            other_git: otherGit,
            pemeriksaan_penunjang: pemeriksaanPenunjang,
            kesimpulan_fisik: kesimpulanFisik,
            is_alergi_makanan: isAlergiMakanan,
            alergi_makanan: alergiMakanan,
            is_pantangan_makanan: isPantanganMakanan,
            pantangan_makanan: pantanganMakanan,
            diet,
            nasi1, nasi2,
            lh1, lh2,
            ln1, ln2,
            sayur1, sayur2,
            buah1, buah2,
            selingan1, selingan2, selingan3,
            planing_diet_type,
            planing_energy,
            planing_carbohydrate,
            planing_protein,
            planing_fat,
        })
    }, [
        id, bbu, tbu, bbtb, lila, rl, estimasiTb, estimasiBbi, kesimpulan, kesimpulanBio, JSON.stringify(git), refGit, otherGit,
        pemeriksaanPenunjang, kesimpulanFisik, isAlergiMakanan, alergiMakanan, isPantanganMakanan, pantanganMakanan,
        diet, nasi1, nasi2, lh1, lh2, ln1, ln2, sayur1, sayur2, buah1, buah2, selingan1, selingan2, selingan3,
        JSON.stringify(recall),
        planing_diet_type,
        planing_energy,
        planing_carbohydrate,
        planing_protein,
        planing_fat,
    ])

    return (
        <>
            <h3>A. Antropometri</h3>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    BB/U
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <select
                            className="form-control form-control-sm col-sm-12"
                            placeholder="BB/U"
                            onChange={e => setBbu(e.target.value)}
                            value={bbu}
                        >
                            {refBbu.map(v => (<option value={v}>{v}</option>))}
                        </select>
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    TB/U
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <select
                            className="form-control form-control-sm col-sm-12"
                            placeholder="TB/U"
                            onChange={e => setTbu(e.target.value)}
                            value={tbu}
                        >
                            {refTbu.map(v => (<option value={v}>{v}</option>))}
                        </select>
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    BB/TB
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <select
                            className="form-control form-control-sm col-sm-12"
                            placeholder="BB/TB"
                            onChange={e => setBbtb(e.target.value)}
                            value={bbtb}
                        >
                            {refBbTb.map(v => (<option value={v}>{v}</option>))}
                        </select>
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Lila
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <div className="input-group input-group-sm">
                            <input
                                className="form-control form-control-sm col-sm-12"
                                type="text"
                                placeholder="Lila"
                                onChange={e => setLila(e.target.value)}
                                value={lila}
                            />
                            <div className="input-group-append">
                                <span className="input-group-text" id="basic-addon2">cm</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    RL
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <div className="input-group input-group-sm">
                            <input
                                className="form-control form-control-sm col-sm-12"
                                type="text"
                                placeholder="RL"
                                onChange={e => setRl(e.target.value)}
                                value={rl}
                            />
                            <div className="input-group-append">
                                <span className="input-group-text" id="basic-addon2">cm</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Estimasi TB
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <div className="input-group input-group-sm">
                            <input
                                className="form-control form-control-sm col-sm-12"
                                type="text"
                                placeholder="Estiamsi TB"
                                onChange={e => setEstimasiTb(e.target.value)}
                                value={estimasiTb}
                            />
                            <div className="input-group-append">
                                <span className="input-group-text" id="basic-addon2">cm</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Estiamsi BBI
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <div className="input-group input-group-sm">
                            <input
                                className="form-control form-control-sm col-sm-12"
                                type="text"
                                placeholder="Estiamsi BBI"
                                onChange={e => setEstimasiBbi(e.target.value)}
                                value={estimasiBbi}
                            />
                            <div className="input-group-append">
                                <span className="input-group-text" id="basic-addon2">kg</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-group row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Kesimpulan Status Gizi
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <textarea
                            className="form-control form-control-sm"
                            placeholder="Kesimpulan Status Gizi"
                            onChange={e => setKesimpulan(e.target.value)}
                            value={kesimpulan}
                        />
                    </div>
                </div>
            </div>
            <h3>B. Biokimia </h3>
            <div className="form-group row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Kesimpulan Biokimia
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <textarea
                            className="form-control form-control-sm"
                            placeholder="Kesimpulan Biokimia"
                            onChange={e => setKesimpulanBio(e.target.value)}
                            value={kesimpulanBio}
                        />
                    </div>
                </div>
            </div>
            <h3>C. Clinik/Fisik</h3>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Gangguan GIT
                </label>
                <div className="col-md-7 ">{refGit.map(mapRefGit)}</div>
            </div>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Gangguan GIT Lainnya
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <input
                            className="form-control form-control-sm col-sm-12"
                            type="text"
                            placeholder="Gangguan GIT Lainnya"
                            onChange={e => setOtherGit(e.target.value)}
                            value={otherGit}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Pemeriksaan Penunjang
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <input
                            className="form-control form-control-sm col-sm-12"
                            type="text"
                            placeholder="Pemeriksaan Penunjang"
                            onChange={e => setPemerikaanPenunjang(e.target.value)}
                            value={pemeriksaanPenunjang}
                        />
                    </div>
                </div>
            </div>
            <div className="form-group row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Kesimpulan Clinic/Fisik
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <textarea
                            className="form-control form-control-sm"
                            placeholder="Kesimpulan Clinic/Fisik"
                            onChange={e => setKesimpulanFisik(e.target.value)}
                            value={kesimpulanFisik}
                        />
                    </div>
                </div>
            </div>
            <h3>D. Dietary History </h3>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Alergi Makanan
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <div className={'col-md-2 pr-2'}>
                            <label className="custom-toggle custom-toggle-success">
                                <input
                                    type="checkbox"
                                    checked={isAlergiMakanan}
                                    onChange={(e) => setIsAlergiMakanan(e.target.checked)}
                                />
                                <span
                                    className="custom-toggle-slider rounded-circle"
                                    data-label-off="Tidak"
                                    data-label-on="Ya"
                                />
                            </label>
                        </div>
                        {isAlergiMakanan && <input
                            className="col-md-10 form-control form-control-sm"
                            type="text"
                            placeholder="Jika ya, sebutkan"
                            value={alergiMakanan}
                            onChange={(e) => setAlergiMakanan(e.target.value)}
                        />}
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Pantangan Makanan
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <div className={'col-md-2 pr-2'}>
                            <label className="custom-toggle custom-toggle-success">
                                <input
                                    type="checkbox"
                                    checked={isPantanganMakanan}
                                    onChange={(e) => setIsPantanganMakanan(e.target.checked)}
                                />
                                <span
                                    className="custom-toggle-slider rounded-circle"
                                    data-label-off="Tidak"
                                    data-label-on="Ya"
                                />
                            </label>
                        </div>
                        {isPantanganMakanan && <input
                            className="col-md-10 form-control form-control-sm"
                            type="text"
                            placeholder="Jika ya, sebutkan"
                            value={pantanganMakanan}
                            onChange={(e) => setPantanganMakanan(e.target.value)}
                        />}
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Diet yang dijalani
                </label>
                <div className="col-md-7">
                    <div className="row">
                        {/* <input
                            className="form-control form-control-sm col-sm-12"
                            type="text"
                            placeholder="Diet yang dijalani"
                            onChange={e => setDiet(e.target.value)}
                            value={diet}
                        /> */}
                        <textarea
                            className="form-control form-control-sm"
                            placeholder="Diet yang dijalani"
                            onChange={e => setDiet(e.target.value)}
                            value={diet}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Pola Makan
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <label
                            className="col-md-3 col-form-label col-form-label-sm"
                        >
                            Nasi
                        </label>
                        <div className="col-md-9">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ flex: 1 }}>
                                    <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        onChange={e => setNasi1(e.target.value)}
                                        value={nasi1}
                                    />
                                </div>
                                <span className={'mx-1'}>x</span>
                                <div style={{ flex: 1 }}>
                                    <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        onChange={e => setNasi2(e.target.value)}
                                        value={nasi2}
                                    />
                                </div>
                                <span className={'ml-1'}>ctg/hr</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    className="col-md-5 col-form-label col-form-label-sm"
                >

                </label>
                <div className="col-md-7">
                    <div className="row">
                        <label
                            className="col-md-3 col-form-label col-form-label-sm"
                        >
                            LH
                        </label>
                        <div className="col-md-9">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ flex: 1 }}>
                                    <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        onChange={e => setLh1(e.target.value)}
                                        value={lh1}
                                    />
                                </div>
                                <span className={'mx-1'}>x</span>
                                <div style={{ flex: 1 }}>
                                    <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        onChange={e => setLh2(e.target.value)}
                                        value={lh2}
                                    />
                                </div>
                                <span className={'ml-1'}>pot/hr</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    className="col-md-5 col-form-label col-form-label-sm"
                >

                </label>
                <div className="col-md-7">
                    <div className="row">
                        <label
                            className="col-md-3 col-form-label col-form-label-sm"
                        >
                            LN
                        </label>
                        <div className="col-md-9">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ flex: 1 }}>
                                    <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        onChange={e => setLn1(e.target.value)}
                                        value={ln1}
                                    />
                                </div>
                                <span className={'mx-1'}>x</span>
                                <div style={{ flex: 1 }}>
                                    <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        onChange={e => setLn2(e.target.value)}
                                        value={ln2}
                                    />
                                </div>
                                <span className={'ml-1'}>pot/hr</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    className="col-md-5 col-form-label col-form-label-sm"
                >

                </label>
                <div className="col-md-7">
                    <div className="row">
                        <label
                            className="col-md-3 col-form-label col-form-label-sm"
                        >
                            Sayur
                        </label>
                        <div className="col-md-9">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ flex: 1 }}>
                                    <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        onChange={e => setSayur1(e.target.value)}
                                        value={sayur1}
                                    />
                                </div>
                                <span className={'mx-1'}>x</span>
                                <div style={{ flex: 1 }}>
                                    <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        onChange={e => setSayur2(e.target.value)}
                                        value={sayur2}
                                    />
                                </div>
                                <span className={'ml-1'}>mkk/hr</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    className="col-md-5 col-form-label col-form-label-sm"
                >

                </label>
                <div className="col-md-7">
                    <div className="row">
                        <label
                            className="col-md-3 col-form-label col-form-label-sm"
                        >
                            Buah
                        </label>
                        <div className="col-md-9">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ flex: 1 }}>
                                    <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        onChange={e => setBuah1(e.target.value)}
                                        value={buah1}
                                    />
                                </div>
                                <span className={'mx-1'}>x bh /</span>
                                <div style={{ flex: 1, display: 'flex' }}>
                                    <div className="custom-control custom-radio ml-3">
                                        <input className="custom-control-input"
                                            id={`buah1`}
                                            type="radio"
                                            checked={buah2 === 'hr'}
                                            onChange={(e) => {
                                                setBuah2('hr')
                                            }}
                                        />
                                        <label className="custom-control-label" htmlFor={`buah1`}>hr</label>
                                    </div>
                                    <div className="custom-control custom-radio ml-3">
                                        <input className="custom-control-input"
                                            id={`buah2`}
                                            type="radio"
                                            checked={buah2 === 'mgg'}
                                            onChange={(e) => {
                                                setBuah2('mgg')
                                            }}
                                        />
                                        <label className="custom-control-label" htmlFor={`buah2`}>mgg</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-group row">
                <label
                    className="col-md-5 col-form-label col-form-label-sm"
                >

                </label>
                <div className="col-md-7">
                    <div className="row">
                        <label
                            className="col-md-3 col-form-label col-form-label-sm"
                        >
                            Selingan
                        </label>
                        <div className="col-md-9">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ flex: 1 }}>
                                    <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        onChange={e => setSelingan1(e.target.value)}
                                        value={selingan1}
                                    />
                                </div>
                                <span className={'mx-1'}>x</span>
                                <div style={{ flex: 1 }}>
                                    <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        onChange={e => setSelingan2(e.target.value)}
                                        value={selingan2}
                                    />
                                </div>
                                <span className={'ml-1'}>/hr : </span>
                                <div style={{ flex: 1 }}>
                                    <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        onChange={e => setSelingan3(e.target.value)}
                                        value={selingan3}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-group row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Recal 24-Jam
                </label>
                <div className="col-md-7">

                    <div className="row">
                        <label className="col-md-3 col-form-label col-form-label-sm">
                            Energi
                        </label>
                        <input
                            className="form-control form-control-sm col-md-9"
                            type="text"
                            placeholder="protein"
                            name="recal_energy"
                            onChange={e => setRecall({ ...recall, recal_energy: e.target.value })}
                            value={recall.recal_energy ?? ''}
                        />
                    </div>
                    <div className="row">
                        <label className="col-md-3 col-form-label col-form-label-sm">
                            Protein
                        </label>
                        <input
                            className="form-control form-control-sm col-md-9"
                            type="text"
                            placeholder="protein"
                            name="recal_protein"
                            onChange={e => setRecall({ ...recall, recal_protein: e.target.value })}
                            value={recall.recal_protein ?? ''}
                        />
                    </div>
                    <div className="row">
                        <label className="col-md-3 col-form-label col-form-label-sm">
                            Lemak
                        </label>
                        <input
                            className="form-control form-control-sm col-md-9"
                            type="text"
                            placeholder="lemak"
                            name="recal_fat"
                            onChange={e => setRecall({ ...recall, recal_fat: e.target.value })}
                            value={recall.recal_fat ?? ''}
                        />
                    </div>
                    <div className="row">
                        <label className="col-md-3 col-form-label col-form-label-sm">
                            karbohidrat
                        </label>
                        <input
                            className="form-control form-control-sm col-md-9"
                            type="text"
                            placeholder="karbohidrat"
                            name="recal_carbohydrate"
                            onChange={e => setRecall({ ...recall, recal_carbohydrate: e.target.value })}
                            value={recall.recal_carbohydrate ?? ''}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ObjectiveGizi